export enum TallyXmlEnum {
    address1 = "ADDRESS",
    address2 = "ADDRESS",
    postalCode = "ADDRESS",
}
